import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-skeleton-loader',
    templateUrl: './skeleton-loader.component.html',
    styleUrl: './skeleton-loader.component.scss'
})
export class SkeletonLoaderComponent implements OnInit {
    @Input() public size: number;
    @Input() public align: string = 'flex-start';
    @Input() type: 'header-with-icon' | 'line' | 'circle' | 'list';
    @Input() width: Array<string> = [];
    @Input() heigth: string;
    @Input() gap: string;
    @Input() viewMode: 'vertical' | 'horizontal' = 'horizontal'

    @ContentChild(TemplateRef) content!: TemplateRef<any>;

    emptyElements: Array<number>;

    public ngOnInit(): void {
        this.emptyElements = Array(this.size).fill(0);
    }
}
